import { Measurement, NullableMeasurement, NullableMeasurementLike } from 'data/models/Measurement';
import { ConvertibleMeasurement, NullableConvertibleMeasurement } from 'lib/ConvertibleMeasurement';
import { ConvertedMeasurement } from 'lib/ConvertedMeasurement';
import { MeasurementInFeetAndInches } from 'lib/MeasurementInFeetAndInches';
import UOM from 'lib/UOM';

export interface ToggleableMeasurementParams {
    backingMeasurement : NullableMeasurementLike,
    uom : () => string,
    conversions : Conversion[]
}

export interface Conversion {
    uom : string,
    decimalPlaces : number,
    feetAndInches? : boolean,
    precision? : number
}

export function ToggleableMeasurement(params : ToggleableMeasurementParams) {
    var convertible = params.backingMeasurement instanceof Measurement
        ? new ConvertibleMeasurement(params.backingMeasurement)
        : params.backingMeasurement instanceof NullableMeasurement
        ? new NullableConvertibleMeasurement(params.backingMeasurement)
        : params.backingMeasurement;

    var conversions = params.conversions.map(conversion => ConversionViewModel(convertible, conversion));

    return {
        uom: params.uom,
        conversions: conversions
    };
}
export type ToggleableMeasurement = ReturnType<typeof ToggleableMeasurement>;

function ConversionViewModel(convertible : NullableMeasurementLike, opts : Conversion) {
    var feetAndInches = opts.uom === UOM.Foot && opts.feetAndInches ?
        new MeasurementInFeetAndInches(convertible, opts.decimalPlaces) : null;

    var converted = feetAndInches ? null : new ConvertedMeasurement(convertible, opts.uom, opts.decimalPlaces, opts.precision);

    return {
        uom: opts.uom,
        feetAndInches: feetAndInches,
        converted: converted
    };
}
type ConversionViewModel = ReturnType<typeof ConversionViewModel>;

interface ToggleableMeasurementViewModelParams {
    model : ToggleableMeasurement,
    textonly: () => boolean,
    tabindex: { _ : number, inches : number },
    disable : boolean,
}

// TH: Thin viewModel
function ToggleableMeasurementViewModel(params : ToggleableMeasurementViewModelParams) {
    return {
        model: params.model, // a ToggleableMeasurement instance
        disable: params.disable, // optional
        textonly: params.textonly,
        tabindex: params.tabindex
    };
}


// WEBPACK FOOTER //
// ./apps/portcall/toggleablemeasurement/model.ts